module.exports = __webpack_public_path__ + "img/plane-booking-gray.80b90ea3.svg";